import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import OrderAddOrUpdate from './components/HubOrderProcessingMain';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import {
  MERCHANT_ROLE_ID, ADDRESS_TYPE_OWN_HUB, ORDER_TYPE_DROP_OFF, ADDRESS_TYPE_MERCHANT,
  ADDRESS_TYPE_ANOTHER_HUB, ADDRESS_TYPE_HUB_CUSTOMER, ORDER_TYPE_PICK_UP,
  ORDER_TYPE_PICK_N_DROP,
  ADDRESS_TYPE_MERCHANT_CUSTOMER,
  ERROR_MESSAGES,

} from '../../../../../utils/pnd/PndConstants';
import { useParams } from 'react-router-dom';
import MerchnatPickUpOrderAddOrUpdate from './components/MerchantOrderProcessingMain';
import { Container } from 'reactstrap';
import { useSelector } from 'react-redux';
const OrderCreationIndex = () => {

  const orderPreferences = useSelector(state => state.orderPreferences);
  useEffect(() => {
    if (localStorage.getItem("uri") != MERCHANT_ROLE_ID) {
      if(orderPreferences?.data?.merchantEnabled){
      getAllMerchantDetails();
      }

    } else {
      getAllMerchantPickupPointDetails();
      getMerchantAssignedHub();
    }
    if (id) {
      getOrderByIdDetails();
    }
  }, []);
  const { id } = useParams();
  const [isInfo, setInfo] = useState(null);
  const [isId, setId] = useState(null);
  const [isRedirect, setIsRedirect] = useState(false);
  const [isCoordinate, setCoordinate] = useState({ latitude: null, longitude: null });
  const [itemDetails, setItemDetails] = useState([{ id: 1 }]);
  const [isMerchantAssignedHub, setMerchantAssignedHub] = useState([]);
  const [isMerchant, setMerchant] = useState([]);
  const [isHub, setHub] = useState([]);
  const [isMerchantPickUpPoint, setMerchantPickUpPoint] = useState([]);
  const [isOrderItemDetails, setOrderItemDetails] = useState([]);
  
  const getOrderByIdDetails = async () => {
    setId(id);
    try {

      const response = await PndRestApi.getOrderByIdById(id);
      if (response.status === 200 && response.data.status === 200) {
        setInfo(response.data.data);

      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };
  const getAllMerchantDetails = async () => {
    try {

      let merchantIds = [];
      const response = await PndRestApi.GetAllMerchantDetails();
      if (response.status === 200 && response.data.status === 200) {
        response.data.data.map(item => {
          merchantIds.push({ "label": item.merchantName, "value": item.merchantId });
        })
        setMerchant(merchantIds);
      } else if (response.status === 200 && response.data.status === 204) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:Please create Merchant first`,
        );
        return;
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };
  const handleSubmit = async (formValues) => {
     try {
      const scheduledDateTimeSlot = formValues?.scheduledDateTimeSlot;
      if (!scheduledDateTimeSlot && localStorage.getItem("uri") != MERCHANT_ROLE_ID) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message:Please select scheduled Date and Time slot first.`,
        );
        return;
      }
      const requestedDateTimeSlot = formValues?.requestedDateTimeSlot;

      if (!requestedDateTimeSlot) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message:Please select requested Date and Time slot first.`,
        );
        return;
      }
      const orderPriorityInfo = formValues?.orderPriorityInfo?.value;
      if (!orderPriorityInfo) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message:Please select the Order Priority.`,
        );
        return;

      }
      /* Common Paramters */
      if (id) {
        formValues["orderId"] = id;
      } else {
        formValues["orderId"] = null;
      }
      formValues["orderType"] = formValues["orderType"] ? formValues["orderType"]["value"] : null;
      formValues["scheduledDateTimeSlot"] = scheduledDateTimeSlot;
      formValues["orderInstruction"] = formValues["orderInstruction"] ? formValues["orderInstruction"] : null;
      formValues["remarks"] = formValues["remarks"] ? formValues["remarks"] : null;
      if (formValues["orderPriorityInfo"]) {
        formValues["orderPriorityInfo"] = {
          "orderPriorityId": formValues["orderPriorityInfo"]["value"]
        }
      }
      if (formValues["orderZoneId"]["value"]) {
        formValues["orderZoneName"] = formValues["orderZoneId"]["label"];
        formValues["orderZoneId"] = formValues["orderZoneId"]["value"];

      }
      formValues["deliveryChargeBearerInfo"] = {
        "deliveryChargeId": formValues["deliveryChargeBearerInfo"]["value"]
      }
      formValues["paymentMethodInfo"] = {
        "paymentMethodId": formValues["paymentMethodInfo"]["value"]
      }
      /** Item Details */
      const itemsArray = [];
      if (id == null || id === "" || id === undefined) {
        itemDetails.forEach(item => {
          const boxDimension = (formValues[`length_${item.id}`] && formValues[`width$_{item.id}`]) ?
            `${formValues[`length_${item.id}`]}X${formValues[`width_${item.id}`]}` :
            (formValues[`length_${item.id}`] && formValues[`width_${item.id}`] && formValues[`height_${item.id}`]) ?
              `${formValues[`length_${item.id}`]}X${formValues[`width_${item.id}`]}X${formValues[`height_${item.id}`]}` : null;
          itemsArray.push({
            noOfItems: formValues[`numberOfBox_${item.id}`],
            weightKg: formValues[`weightKg_${item.id}`],
            boxDescription: formValues[`boxDescription_${item.id}`],
            boxDimension: boxDimension,

          });
        });
      } else {
        isOrderItemDetails.forEach(item => {
          const boxDimension = (formValues[`length_${item.id}`] && formValues[`width_${item.id}`]) ?
            `${formValues[`length_${item.id}`]}X${formValues[`width_${item.id}`]}` :
            (formValues[`length_${item.id}`] && formValues[`width_${item.id}`] && formValues[`height_${item.id}`]) ?
              `${formValues[`length_${item.id}`]}X${formValues[`width_${item.id}`]}X${formValues[`height_${item.id}`]}` : null;
          itemsArray.push({
            noOfItems: formValues[`numberOfBox_${item.id}`],
            weightKg: formValues[`weightKg_${item.id}`],
            boxDescription: formValues[`boxDescription_${item.id}`],
            boxDimension: boxDimension,
            boxBarCode: formValues[`boxBarCode_${item.id}`],
          });
        });
      }
      formValues["orderItemDetailsInfo"] = itemsArray;

      /*** PICK UP */

      if (formValues["orderType"] == ORDER_TYPE_PICK_UP) {
        if (localStorage.getItem("uri") != MERCHANT_ROLE_ID) {
          const collectionPointValue = formValues?.collectionPointId?.value;
          if (collectionPointValue) {
            formValues["collectionPointName"] = formValues["collectionPointId"]["label"];
            formValues["collectionPointId"] = formValues["collectionPointId"]["value"];
          } else {
            formValues["collectionPointId"] = null;
          }

          formValues["orderToAddressTypeInfo"] = {
            "orderAddressTypeId": ADDRESS_TYPE_OWN_HUB,
          }
          formValues["toUniqueId"] = localStorage.getItem("hi");
          if (formValues["orderFromAddressTypeInfo"]["value"] == ADDRESS_TYPE_HUB_CUSTOMER) {
            formValues["fromUniqueId"] = formValues["name"]["value"];
            formValues["name"] = formValues["name"]["label"];
          }

          else if (formValues["orderFromAddressTypeInfo"]["value"] == ADDRESS_TYPE_MERCHANT) {
            formValues["fromUniqueId"] = collectionPointValue ? collectionPointValue : null;

            const name = formValues?.name?.label;
            if (name == null || name == undefined) {
              formValues["name"] = null;
            }


            formValues["merchantInfo"] = {
              "merchantId": formValues["merchantInfo"]["value"]
            }
            if (formValues["dropOffRequiredLater"]) {
              formValues["dropOffRequiredLater"] = true;
              formValues["name"] = formValues["name"]["label"] ? formValues["name"]["label"] : null
            } else {
              formValues["dropOffRequiredLater"] = false;
            }
          }
          if (formValues["orderFromAddressTypeInfo"]["value"] == ADDRESS_TYPE_ANOTHER_HUB) {
            formValues["fromUniqueId"] = formValues["hubInfo"]["value"];
            formValues["hubInfo"] = null;
            formValues["name"] = null;
          }
          if (formValues["orderFromAddressTypeInfo"]["value"] == ADDRESS_TYPE_MERCHANT_CUSTOMER) {
            formValues["name"] = formValues["name"]["label"] ? formValues["name"]["label"] : null
          }
          // else{
          //   formValues["name"] = null;
          // }
          formValues["orderFromAddressTypeInfo"] = {
            "orderAddressTypeId": formValues["orderFromAddressTypeInfo"]["value"],
          }
          const toAddressName = formValues?.toAddressName?.value;
          if (toAddressName) {
            formValues["toAddressName"] = formValues?.toAddressName?.label ? formValues["toAddressName"]["label"] : null;
          } else {
            formValues["toAddressName"] = null;
          }
        } else {
          const collectionPointValue = formValues?.orderFromAddressTypeInfo?.value;
          /*** Case 1- Pick Up From 	Merchant	Drop it off Own hub ** */
          formValues["merchantInfo"] = {
            "merchantId": localStorage.getItem("mi")
          }
          formValues["orderToAddressTypeInfo"] = {
            "orderAddressTypeId": ADDRESS_TYPE_OWN_HUB,
          }
          formValues["toUniqueId"] = formValues["toUniqueId"]["value"];


          if (collectionPointValue != 0) { /** if it is not Merchant customer */
            formValues["fromUniqueId"] = formValues["orderFromAddressTypeInfo"]["value"];
            if (collectionPointValue) {
              formValues["collectionPointName"] = formValues["orderFromAddressTypeInfo"]["label"];
              formValues["collectionPointId"] = formValues["orderFromAddressTypeInfo"]["value"];
            }
            formValues["orderFromAddressTypeInfo"] = {
              "orderAddressTypeId": ADDRESS_TYPE_MERCHANT,
            }
            const name = formValues?.name?.label;
            if (name) {
              formValues["name"] = formValues["name"]["label"];
            } else {
              formValues["name"] = null;
            }

            //const collectionPointValue = formValues?.collectionPointId?.value;


            const toAddressName = formValues?.toAddressName?.value;
            if (toAddressName) {
              formValues["toAddressName"] = formValues?.toAddressName?.label ? formValues["toAddressName"]["label"] : null;
            } else {
              formValues["toAddressName"] = null;
            }
          } else { /** Pick Up Point is Merchant customer*/
            if (!formValues["dropOffRequiredLater"]) {
              formValues["fromUniqueId"] = formValues["name"]?.value ?? formValues["fromUniqueId"];
              formValues["name"] = formValues["name"]?.label ?? (typeof formValues["name"] === 'string' ? formValues["name"] : null);
              formValues["orderFromAddressTypeInfo"] = {
                "orderAddressTypeId": ADDRESS_TYPE_MERCHANT_CUSTOMER,
              }
              formValues["orderToAddressTypeInfo"] = {
                "orderAddressTypeId": ADDRESS_TYPE_OWN_HUB,
              }
              if (formValues["toUniqueId"] && typeof formValues["toUniqueId"] === 'object') {
                formValues["toUniqueId"] = formValues["toUniqueId"]["value"];
              }
            } else {

              formValues["fromUniqueId"] = formValues["name"]?.value ?? formValues["fromUniqueId"];
              formValues["name"] = formValues["name"]?.label ?? (typeof formValues["name"] === 'string' ? formValues["name"] : null);
              const dropoffRequiredLaterCustomerName = formValues["toAddressName"]?.label ?? formValues["toAddressName"];
              if (dropoffRequiredLaterCustomerName != null) {
                formValues["toAddressName"] = formValues["toAddressName"]?.label ?? formValues["toAddressName"];
                formValues["orderFromAddressTypeInfo"] = {
                  "orderAddressTypeId": ADDRESS_TYPE_MERCHANT_CUSTOMER,
                }
              }

            }
          }

        }

      }


      /** Drop Off */
      else if (formValues["orderType"] == ORDER_TYPE_DROP_OFF) {
        formValues["dropOffRequiredLater"] = false;
        formValues["collectionPointId"] = null;
        formValues["orderFromAddressTypeInfo"] = {
          "orderAddressTypeId": ADDRESS_TYPE_OWN_HUB,
        }
        formValues["fromUniqueId"] = localStorage.getItem("hi");

        if (formValues["orderToAddressTypeInfo"]["value"] == ADDRESS_TYPE_HUB_CUSTOMER) {
          formValues["toUniqueId"] = formValues["name"]["value"];
          formValues["name"] = formValues["name"]["label"];
        }

        if (formValues["orderToAddressTypeInfo"]["value"] == ADDRESS_TYPE_MERCHANT) {
          formValues["toUniqueId"] = formValues["merchantInfo"]["value"];
          formValues["merchantInfo"] = {
            "merchantId": formValues["merchantInfo"]["value"]
          }
          formValues["name"] = null;

        } else {
          formValues["merchantInfo"] = null;
        }
        if (formValues["orderToAddressTypeInfo"]["value"] == ADDRESS_TYPE_ANOTHER_HUB) {
          formValues["toUniqueId"] = formValues["hubInfo"]["value"];

          formValues["name"] = null;

        }
        formValues["orderToAddressTypeInfo"] = {
          "orderAddressTypeId": formValues["orderToAddressTypeInfo"]["value"],
        }
        formValues["dropOffHubInfo"] = null;
        formValues["toAddressName"] = null;

      }

      /********** PICK AND DROP ************/
      else if (formValues["orderType"] == ORDER_TYPE_PICK_N_DROP) {
         formValues["dropOffRequiredLater"] = false;
        const collectionPointValue = formValues?.collectionPointId?.value;
        if (collectionPointValue) {
          formValues["collectionPointName"] = formValues?.collectionPointId?.label;
          formValues["collectionPointId"] = formValues?.collectionPointId?.value;
        } else {
          if (localStorage.getItem("uri") == MERCHANT_ROLE_ID) {
            formValues["collectionPointId"] = formValues?.orderFromAddressTypeInfo?.value;
            formValues["collectionPointName"] = formValues?.orderFromAddressTypeInfo?.label;

          } else {
            formValues["collectionPointId"] = null;
          }
        }
        if (formValues?.orderFromAddressTypeInfo?.value !== 0 && localStorage.getItem("uri") != MERCHANT_ROLE_ID) {
          formValues.orderFromAddressTypeInfo = {
            orderAddressTypeId: formValues?.orderFromAddressTypeInfo?.value,
          };

        } else {
          if (formValues?.orderFromAddressTypeInfo == 0 || formValues?.orderFromAddressTypeInfo?.value === 0) {
            formValues["orderFromAddressTypeInfo"] = {
              "orderAddressTypeId": ADDRESS_TYPE_MERCHANT_CUSTOMER,
            }
          } else {
            formValues["orderFromAddressTypeInfo"] = {
              "orderAddressTypeId": ADDRESS_TYPE_MERCHANT,
            }
          }
        }
        if (formValues?.orderToAddressTypeInfo?.value) {
          formValues.orderToAddressTypeInfo = {
            orderAddressTypeId: formValues?.orderToAddressTypeInfo?.value,
          };
        }




        if (localStorage.getItem("uri") != MERCHANT_ROLE_ID) {

          if (formValues?.orderFromAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_MERCHANT) {
            formValues["fromUniqueId"] = collectionPointValue ? collectionPointValue : null;
            formValues["merchantInfo"] = {
              "merchantId": formValues["merchantInfo"]["value"]
            }
          }

          if (formValues?.orderFromAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_ANOTHER_HUB) {
            formValues["fromUniqueId"] = formValues["hubInfo"]["value"];
          }

          if (formValues?.orderToAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_ANOTHER_HUB) {
            formValues["toUniqueId"] = formValues["dropOffHubInfo"]["value"];

          }

          if (formValues?.name?.label) {
            formValues["name"] = formValues?.name?.label;
          } else {
            formValues["name"] = null;
          }
          if (formValues?.orderToAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_HUB_CUSTOMER || formValues?.orderToAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_MERCHANT_CUSTOMER) {
            formValues["toUniqueId"] = formValues["name"]["value"];
          }

          // if ((formValues?.orderFromAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_HUB_CUSTOMER || formValues?.orderFromAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_MERCHANT_CUSTOMER) && formValues?.toAddressName?.label) {
          //   formValues["toAddressName"] = formValues["toAddressName"]["label"];
          // }

          if (formValues?.toAddressName?.label) {
            formValues["toAddressName"] = formValues?.toAddressName?.label;
          } else {
            formValues["toAddressName"] = null;
          }

        } else {
          if (formValues?.orderFromAddressTypeInfo?.orderAddressTypeId == 0
            && formValues?.orderToAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_MERCHANT_CUSTOMER) {

            formValues["toUniqueId"] = formValues["toUniqueId"]["value"];
            formValues["name"] = formValues["name"]["label"];
            formValues["toAddressName"] = formValues["toAddressName"]["label"];
            formValues["merchantInfo"] = {
              "merchantId": localStorage.getItem("mi")
            }
          }

          else {
            if (formValues?.orderFromAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_MERCHANT_CUSTOMER && formValues?.orderToAddressTypeInfo?.orderAddressTypeId == ADDRESS_TYPE_MERCHANT_CUSTOMER) {
              formValues["collectionPointId"] = null;
            }
            formValues["fromUniqueId"] = formValues?.orderFromAddressTypeInfo?.orderAddressTypeId;
            formValues["toUniqueId"] = formValues["toUniqueId"]["value"];
            formValues["merchantInfo"] = {
              "merchantId": localStorage.getItem("mi")
            }
            if (formValues?.name?.label !== undefined) {
              formValues["name"] = formValues["name"]["label"];
            }
            if (formValues?.toAddressName?.label !== undefined) {
              formValues["toAddressName"] = formValues["toAddressName"]["label"];
            }

          }
        }

      }

      const response = await PndRestApi.AddorUpdateOrderDetails(formValues);
      if (response.status === 200 && response.data.status === 200) {

        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message: ${response.data?.data}`
        );
        setIsRedirect(true);
        // setTimeout(() => {
        //   setIsRedirect(true);
        // }, PAGE_TIMEOUT);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`,
        );
      }
    } catch (error) {
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        `Message:Network Error Occured. Please try after sometime`,
      );
    }
  };
  const getAllMerchantPickupPointDetails = async () => {
    try {

      const response = await PndRestApi.GetAllPickUpPointsDetails(localStorage.getItem('mi'));
      if (response.status === 200 && response.data.status === 200) {
        const pickUpPointsId = [{ "label": "Merchant Customer", "value": 0 }]; //ADDRESS_TYPE_MERCHANT_CUSTOMER - 5 but may be merchant collection point will have value 5
        response.data.data.map(item => {
          pickUpPointsId.push({ "label": item.collectionPointName, "value": item.pickUpPointPointId });
        })
        setMerchantPickUpPoint(pickUpPointsId);
      } else if (response?.data?.status && response?.data?.status === 204) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:Please create pick up point`,
        );
        return;
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data?.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };

  const getMerchantAssignedHub = async () => {
    try {

      let hubIds = [];
      const response = await PndRestApi.GetMerchantAssignedHub();
      if (response.status === 200 && response.data.status === 200) {
        response.data.data.map(item => {
          hubIds.push({ "label": item.hubTypeDescription + " (" + item.hubName + ")", "value": item.hubId });
        })
        setMerchantAssignedHub(hubIds);
      } else if (response.status === 200 && response.data.status === 204) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:No Hub Found`,
        );
        return;
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };
  if (isRedirect) {
    //window.location.reload();
    return <Redirect to="/web_app/pnd_order/order_details" />;
  }

  return (
    <Container>
      {MERCHANT_ROLE_ID != localStorage.getItem("uri") && isInfo == null &&
        <OrderAddOrUpdate onSubmit={handleSubmit} setItemDetails={setItemDetails} itemDetails={itemDetails} isMerchant={isMerchant} isHub={isHub} setHub={setHub} />}
      {MERCHANT_ROLE_ID != localStorage.getItem("uri") && isInfo != null && isId != null &&
        <OrderAddOrUpdate onSubmit={handleSubmit} isInfo={isInfo} setCoordinate={setCoordinate}
          itemDetails={itemDetails} setItemDetails={setItemDetails} isId={isId} isMerchant={isMerchant} isHub={isHub} setHub={setHub} isOrderItemDetails={isOrderItemDetails} setOrderItemDetails={setOrderItemDetails} />
      }
      {
        MERCHANT_ROLE_ID == localStorage.getItem("uri") && isInfo == null &&
        <MerchnatPickUpOrderAddOrUpdate onSubmit={handleSubmit} setItemDetails={setItemDetails}
          itemDetails={itemDetails} isMerchantPickUpPoint={isMerchantPickUpPoint} isMerchantAssignedHub={isMerchantAssignedHub} />}

      {
        MERCHANT_ROLE_ID == localStorage.getItem("uri") && isInfo != null && isId != null &&
        <MerchnatPickUpOrderAddOrUpdate onSubmit={handleSubmit} isInfo={isInfo} setCoordinate={setCoordinate} isMerchantPickUpPoint={isMerchantPickUpPoint}
          isMerchantAssignedHub={isMerchantAssignedHub} isId={isId} isHub={isHub} setHub={setHub} isOrderItemDetails={isOrderItemDetails}
          setOrderItemDetails={setOrderItemDetails} setItemDetails={setItemDetails} itemDetails={itemDetails} />}

    </Container>
  );
};

export default OrderCreationIndex;

